import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_NAFTA_PSF_SHARE_COPY_BANDIT_TRAFFIC_CONFIG = createFcmDetails(
	'nafta_psf_share_copy_bandit_traffic_config',
	{
		owner: 'TBD',
		context: 'PSF share page',
		description: 'Used to limit psf-share-xyz_locale bandit based on ?share=xyz query param',
		import: false,
		template: {
			message: 100,
			skip: 100,
			initial: 100,
		},
	},
);
